import React from 'react';
import FlecheRevenirSvg from "../../../boiteAOutils/SVG/FlecheRevenirSvg";
import {useStores} from "../../../stores/Context";
import PlusSvg from "../../../boiteAOutils/SVG/PlusSvg";
import ParametreSvg from "../../../boiteAOutils/SVG/ParametreSvg";

const WidgetBibliothequeImageBtn = () => {
    const {uiStore, bibliothequeImagesStore} = useStores();
    const handleGoHome = (event) => {
        event.preventDefault();
        uiStore.closeConsultingIndicateurWidget();
        bibliothequeImagesStore.handleResetViews();
    }

    const handleAddImageView = () => {

        bibliothequeImagesStore.handleOpenAddPhoto();
    }


    return (
        <div className={"navBarWidgetBtnContent"}>
            <div className={"widgetsNavBarContentIcons"} onClick={handleGoHome}>
                <FlecheRevenirSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
            </div>

            <div className={"widgetsNavBarContentIcons"} onClick={handleAddImageView}>
                <PlusSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Ajouter</span>
            </div>
        </div>
    );
};

export default WidgetBibliothequeImageBtn;